/**
 * Page routed at "/account/submissions/:submissionId" (pages/user/UserHomepage),
 * showing a user's own submission. Stacks SubmissionDisplay (owner view of the
 * submission, product link visible) above SubheadedBountyDisplay in "public"
 * mode (read-only view of the bounty the submission targets). Both children
 * read their data from router location.state.
 */
import SubmissionDisplay from "@/pages/submission/SubmissionDisplay";
import SubheadedBountyDisplay from "@/pages/bounty/SubheadedBountyDisplay";

const SubmissionBountyDisplay: React.FC = () => {
    return (
        <div className="flex flex-col w-full pb-16">
            <SubmissionDisplay submissionType="normal" type="owner" />
            <SubheadedBountyDisplay type="public" />
        </div>
    );
};

export default SubmissionBountyDisplay;
